import { Mic, MicOff, Radio } from "lucide-react";
import { toast } from "sonner";
import { Slider } from "@/components/ui/slider";

const Meter = ({ level }) => (
  <div className="flex gap-1 h-4" data-testid="studio-mic-meter">
    {Array.from({ length: 24 }).map((_, i) => (
      <span key={i} className="flex-1 rounded-sm transition-opacity duration-75"
        style={{ opacity: level * 24 > i ? 1 : 0.15, background: i > 19 ? "var(--red)" : i > 14 ? "var(--gold)" : "var(--green)" }} />
    ))}
  </div>
);

export const MicPanel = ({ mic }) => {
  const live = mic.state === "live";
  const go = async () => {
    if (mic.state !== "off") return mic.stop();
    try { await mic.start(); } catch { toast.error("Microphone blocked. Allow mic access in your browser to go live."); }
  };
  return (
    <section className={`panel p-5 flex flex-col gap-4 ${live ? "border-[color:var(--onair)]" : ""}`} data-testid="studio-mic-panel">
      <div className="flex items-center justify-between">
        <span className="eyebrow">Live mic</span>
        <span className={`font-mono text-xs tracking-widest ${live ? "text-[color:var(--onair)]" : "text-[color:var(--lr-muted)]"}`} data-testid="studio-on-air-indicator">
          {live ? (mic.muted ? "MIC MUTED" : "ON AIR") : mic.state === "connecting" ? "CONNECTING" : "OFF AIR"}
        </span>
      </div>
      <button onClick={go} className={`rounded-xl py-5 font-display text-3xl tracking-wider flex items-center justify-center gap-3 transition-[background-color,transform] active:scale-[0.98] ${live ? "bg-[color:var(--onair)] on-air-pulse" : "bg-white/5 border border-[color:var(--red)] hover:bg-[color:var(--red)]/20"}`} data-testid="studio-go-live-button">
        <Radio className="w-6 h-6" /> {live ? "End live" : mic.state === "connecting" ? "Connecting..." : "Go live"}
      </button>
      <Meter level={mic.level} />
      <div className="flex items-center gap-4">
        <button onClick={mic.toggleMute} disabled={!live} className="rounded-lg border border-white/15 px-3 py-2 text-sm flex items-center gap-2 disabled:opacity-40 hover:bg-white/10" data-testid="studio-mic-mute-button">
          {mic.muted ? <MicOff className="w-4 h-4 text-[color:var(--red)]" /> : <Mic className="w-4 h-4" />} {mic.muted ? "Unmute" : "Mute"}
        </button>
        <span className="font-mono text-xs text-[color:var(--lr-muted)]">GAIN</span>
        <Slider value={[mic.gain * 100]} min={20} max={200} step={5} onValueChange={(v) => mic.setGain(v[0] / 100)} className="flex-1" data-testid="studio-mic-gain-slider" />
      </div>
      <p className="text-xs text-[color:var(--lr-muted)]">Music ducks automatically while you're live. Listeners hear you a few seconds later.</p>
    </section>
  );
};
